// composables/useFetch.js
import { ref } from "vue"
import { ofetch } from "ofetch"
import { useUserStore } from "~/stores/userStore"

export const useOFetch = async (
    method: string,
    url: string,
    body: any = null
): Promise<any> => {
    const config = useRuntimeConfig()

    const baseUrl = ref(config.public.HOMEDELI_API_BASE_URL)

    const userStore = useUserStore()

    const { user } = storeToRefs(userStore)

    let defaultHeaders = {
        Accept: "application/json",
        "Content-Type": "application/json",
    }

    let finalHeaders = {}

    if (user.value.access_token) {
        finalHeaders = {
            ...defaultHeaders,
            token: user.value.access_token,
        }
    } else {
        finalHeaders = {
            ...defaultHeaders,
        }
    }
    try {
        return await ofetch(baseUrl.value + "/" + url, {
            method: method,
            body: body,
            headers: finalHeaders,
        })
    } catch (error) {
        throw error
    }
}
